<!--
Copyright 2023 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
@if (!showRealTime) {
  <span>{{ getDeltaTime(durationSeconds) }}</span>
}
@if (showRealTime) {
  <span [title]="'Time shown in your browser timezone'">{{ getDate(durationSeconds) }}</span>
}

